"use client";

import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import homeStyles from "../../Home.module.css";
import ForWhoQuote from "./components/ForWhoQuote";
import ForWhoReading from "./components/ForWhoReading";
import { HOME_ROLES } from "./ForWho.logic";
import styles from "./ForWho.module.css";

export default function ForWho() {
  const T = useT();

  return (
    <div className={styles.band}>
      <div className={styles.container}>
        <div className={homeStyles.titles}>
          <span className={homeStyles.supTitle}>{T(TKey.HOME_WHO_SUP_TITLE)}</span>
          <h2 className={homeStyles.statement}>
            <span className={styles.titleLine}>{T(TKey.HOME_WHO_TITLE)}</span>
            <span className={styles.titleLine}>{T(TKey.HOME_WHO_TITLE_2)}</span>
          </h2>
        </div>

        <div className={styles.stage}>
          <ForWhoQuote />

          <ul className={styles.readings}>
            {HOME_ROLES.map((role) => (
              <ForWhoReading key={role.titleKey} role={role} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
